import { Check, MessageCircle } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { waLink, WA, IMAGES } from "../config/site";

const SERVICES = [
  "Men's alterations",
  "Women's alterations",
  "Garment fitting & modification",
  "Boutique services",
];

export const Boutique = () => (
  <section
    id="alterations"
    className="py-16 sm:py-24 lg:py-32 bg-charcoal-surface border-y border-white/10 relative overflow-hidden"
  >
    <div
      className="absolute -bottom-40 -left-40 w-[480px] h-[480px] rounded-full bg-gold/[0.06] blur-3xl"
      aria-hidden="true"
    />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center relative">
      <Reveal>
        <Eyebrow>Boutique & Alterations</Eyebrow>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-cream text-balance">
          Perfect Fit, <span className="italic text-gold">Every Time.</span>
        </h2>
        <p className="mt-6 text-base sm:text-lg text-cream/60 leading-relaxed max-w-lg">
          A garment that fits well feels made for you. Om Sri Sri Collection
          provides professional boutique and alteration services for both men
          and women — so what you wear always sits just right.
        </p>
        <ul className="mt-8 space-y-3.5">
          {SERVICES.map((s) => (
            <li key={s} className="flex items-center gap-3.5 text-cream/80">
              <span className="w-7 h-7 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center text-gold shrink-0">
                <Check size={14} strokeWidth={3} />
              </span>
              <span className="text-sm sm:text-base">{s}</span>
            </li>
          ))}
        </ul>
        <a
          href={waLink(WA.alteration)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="boutique-enquiry-button"
          className="mt-10 inline-flex items-center gap-2.5 bg-gold text-charcoal font-semibold rounded-full px-7 py-3.5 hover:bg-gold-hover transition-all duration-300 hover:-translate-y-0.5 shadow-[0_10px_40px_-10px_rgba(212,175,55,0.5)]"
        >
          <MessageCircle size={18} />
          Ask About Alterations
        </a>
      </Reveal>

      <Reveal delay={0.15} className="relative">
        <div
          className="absolute -inset-3 rounded-[2.2rem] border border-gold/25 translate-x-4 translate-y-4"
          aria-hidden="true"
        />
        <div className="relative rounded-[2rem] overflow-hidden img-frame">
          <img
            src={IMAGES.boutique}
            alt="Tailor at work — professional boutique and alteration services for men and women"
            loading="lazy"
            decoding="async"
            className="w-full h-[420px] sm:h-[520px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 via-transparent to-transparent" />
          <p className="absolute bottom-6 left-6 font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-gold">
            In-house tailoring · Men & Women
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
